"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.FILE_POSTFIXES = exports.LOCAL_FILENAMES = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _FileSystemWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/FileSystemWrapper"));

var _FileTransferWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/FileTransferWrapper"));

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var _ErrorHelper = require("./ErrorHelper");

// eslint-disable-line
var LOCAL_FILENAMES = {
  ALL_CONTENT: 'allcontent.zip',
  CONTENT_PARTS: 'content_parts.zip',
  DATA_FOLDER: 'data',
  DOCUMENTSAVE_FOLDER: 'privatedocuments',
  DOCUMENTSAVE_THUMB_FOLDER: 'privatedocuments_thumbs',
  FILELIST: 'filelist.json',
  FLEXMENU: 'flexmenu.json',
  UPDATE_FOLDER: 'update',
  VIDEO_FOLDER: 'videos',
  DOWNLOAD_FOLDER: 'downloads',
  // folders in data and update
  SUBFOLDER_STRINGS: 'strings',
  SUBFOLDER_CSS: 'css',
  SUBFOLDER_IMG: 'img',
  SUBFOLDER_DOCS: 'docs',
  SUBFOLDER_THUMBS: 'thumbs',
  SUBFOLDER_SETTINGS: 'settings'
};
exports.LOCAL_FILENAMES = LOCAL_FILENAMES;
var FILE_POSTFIXES = {
  VIDEO_MP4: '.mp4'
};
exports.FILE_POSTFIXES = FILE_POSTFIXES;
var dataFolderPath = null; // will be set in initFolderNames

var downloadFolderPath = null; // will be set in

var CordovaFileHelper = /*#__PURE__*/function () {
  function CordovaFileHelper() {
    (0, _classCallCheck2["default"])(this, CordovaFileHelper);
  }

  (0, _createClass2["default"])(CordovaFileHelper, null, [{
    key: "createFolder",

    /**
     * When creating subfolders make sure the parent folder exists and the child does not
     * @param foldername
     * @returns {Promise<*>}
     */
    value: function () {
      var _createFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(foldername) {
        var fileSystem, subfolders, parentFolder, i, subfolder;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", _promise["default"].resolve());

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 5:
                fileSystem = _context.sent;
                subfolders = foldername.split('/');

                if (!(subfolders.length === 1)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, foldername, {
                  create: true
                }));

              case 9:
                _context.next = 11;
                return _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, subfolders[0]);

              case 11:
                parentFolder = _context.sent;
                i = 1;

              case 13:
                if (!(i < subfolders.length)) {
                  _context.next = 21;
                  break;
                }

                subfolder = subfolders[i];
                _context.next = 17;
                return _FileSystemWrapper["default"].getDirectoryEntry(parentFolder, subfolder, {
                  create: true
                });

              case 17:
                parentFolder = _context.sent;

              case 18:
                i++;
                _context.next = 13;
                break;

              case 21:
                return _context.abrupt("return", _promise["default"].resolve());

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](2);
                (0, _ErrorHelper.addAdditionalDataToError)(_context.t0, {
                  folder: foldername,
                  method: 'createFolder'
                });
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 24]]);
      }));

      function createFolder(_x) {
        return _createFolder.apply(this, arguments);
      }

      return createFolder;
    }()
  }, {
    key: "initFolderNames",
    value: function () {
      var _initFolderNames = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var fileSystem;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", _promise["default"].resolve());

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 5:
                fileSystem = _context2.sent;
                dataFolderPath = "".concat(fileSystem.root.nativeURL).concat(LOCAL_FILENAMES.DATA_FOLDER, "/");
                downloadFolderPath = "".concat(fileSystem.root.nativeURL).concat(LOCAL_FILENAMES.DOWNLOAD_FOLDER, "/");
                return _context2.abrupt("return", _promise["default"].resolve(dataFolderPath));

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                (0, _ErrorHelper.addAdditionalDataToError)(_context2.t0, {
                  method: 'initFolderNames'
                });
                return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11]]);
      }));

      function initFolderNames() {
        return _initFolderNames.apply(this, arguments);
      }

      return initFolderNames;
    }()
  }, {
    key: "getDataFolder",
    value: function getDataFolder() {
      if (_DeviceInfoHelper["default"].isBrowser()) {
        return _promise["default"].resolve();
      }

      return dataFolderPath;
    }
  }, {
    key: "deleteFile",
    value: function () {
      var _deleteFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(filename) {
        var foldername,
            fileEntry,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                foldername = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", _promise["default"].resolve());

              case 3:
                _context3.prev = 3;
                _context3.next = 6;
                return CordovaFileHelper.getFileEntry(filename, foldername);

              case 6:
                fileEntry = _context3.sent;
                _context3.next = 9;
                return _FileSystemWrapper["default"].removeFile(fileEntry);

              case 9:
                return _context3.abrupt("return", _promise["default"].resolve());

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](3);

                if (!(_context3.t0.code === window.FileError.NOT_FOUND_ERR)) {
                  _context3.next = 16;
                  break;
                }

                return _context3.abrupt("return", _promise["default"].resolve());

              case 16:
                (0, _ErrorHelper.addAdditionalDataToError)(_context3.t0, {
                  filename: filename,
                  folder: foldername,
                  method: 'deleteFile'
                });
                return _context3.abrupt("return", _promise["default"].reject(_context3.t0));

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 12]]);
      }));

      function deleteFile(_x2) {
        return _deleteFile.apply(this, arguments);
      }

      return deleteFile;
    }()
  }, {
    key: "deleteDirectory",
    value: function () {
      var _deleteDirectory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(dirname) {
        var fileSystem, dirEntry;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", _promise["default"].resolve());

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 5:
                fileSystem = _context4.sent;
                _context4.next = 8;
                return _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, dirname, {
                  create: false
                });

              case 8:
                dirEntry = _context4.sent;
                _context4.next = 11;
                return _FileSystemWrapper["default"].removeDirectory(dirEntry);

              case 11:
                return _context4.abrupt("return", _promise["default"].resolve());

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](2);

                if (!(_context4.t0.code === window.FileError.NOT_FOUND_ERR)) {
                  _context4.next = 18;
                  break;
                }

                return _context4.abrupt("return", _promise["default"].resolve());

              case 18:
                (0, _ErrorHelper.addAdditionalDataToError)(_context4.t0, {
                  folder: dirname,
                  method: 'deleteDirectory'
                });
                return _context4.abrupt("return", _promise["default"].reject(_context4.t0));

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 14]]);
      }));

      function deleteDirectory(_x3) {
        return _deleteDirectory.apply(this, arguments);
      }

      return deleteDirectory;
    }()
  }, {
    key: "getFolderEntry",
    value: function () {
      var _getFolderEntry = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(foldername) {
        var createIfNotExisting,
            fileSystem,
            folderEntry,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                createIfNotExisting = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", _promise["default"].resolve());

              case 3:
                _context5.prev = 3;
                _context5.next = 6;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 6:
                fileSystem = _context5.sent;
                _context5.next = 9;
                return _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, foldername, {
                  create: createIfNotExisting
                });

              case 9:
                folderEntry = _context5.sent;
                return _context5.abrupt("return", _promise["default"].resolve(folderEntry));

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](3);
                (0, _ErrorHelper.addAdditionalDataToError)(_context5.t0, {
                  folder: foldername,
                  method: 'getFolderEntry'
                });
                return _context5.abrupt("return", _promise["default"].reject(_context5.t0));

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[3, 13]]);
      }));

      function getFolderEntry(_x4) {
        return _getFolderEntry.apply(this, arguments);
      }

      return getFolderEntry;
    }()
  }, {
    key: "getFolderContent",
    value: function () {
      var _getFolderContent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(foldername) {
        var fileSystem, folderEntry;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", _promise["default"].resolve());

              case 2:
                _context6.prev = 2;
                _context6.next = 5;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 5:
                fileSystem = _context6.sent;
                _context6.next = 8;
                return _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, foldername, {
                  create: true
                });

              case 8:
                folderEntry = _context6.sent;

                if (!folderEntry) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 12;
                return _FileSystemWrapper["default"].getDirContent(folderEntry);

              case 12:
                folderEntry.entries = _context6.sent;
                return _context6.abrupt("return", _promise["default"].resolve(folderEntry));

              case 16:
                return _context6.abrupt("return", _promise["default"].resolve());

              case 17:
                _context6.next = 23;
                break;

              case 19:
                _context6.prev = 19;
                _context6.t0 = _context6["catch"](2);
                (0, _ErrorHelper.addAdditionalDataToError)(_context6.t0, {
                  folder: foldername,
                  method: 'getFolderContent'
                });
                return _context6.abrupt("return", _promise["default"].reject(_context6.t0));

              case 23:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 19]]);
      }));

      function getFolderContent(_x5) {
        return _getFolderContent.apply(this, arguments);
      }

      return getFolderContent;
    }()
  }, {
    key: "getAllFileEntries",
    value: function () {
      var _getAllFileEntries = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var foldername,
            fileSystem,
            directoryEntry,
            dirContent,
            imgEntry,
            docsEntry,
            thumbsEntry,
            stringsEntry,
            cssEntry,
            settingsEntry,
            imgContent,
            docsContent,
            thumbsContent,
            stringsContent,
            cssContent,
            settingsContent,
            entries,
            _args7 = arguments;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                foldername = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : LOCAL_FILENAMES.UPDATE_FOLDER;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return", _promise["default"].resolve());

              case 3:
                _context7.prev = 3;
                _context7.next = 6;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 6:
                fileSystem = _context7.sent;
                _context7.next = 9;
                return _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, foldername, {});

              case 9:
                directoryEntry = _context7.sent;
                _context7.next = 12;
                return _FileSystemWrapper["default"].getDirContent(directoryEntry);

              case 12:
                dirContent = _context7.sent;
                imgEntry = dirContent.find(function (entry) {
                  return entry.name === 'img';
                });
                docsEntry = dirContent.find(function (entry) {
                  return entry.name === 'docs';
                });
                thumbsEntry = dirContent.find(function (entry) {
                  return entry.name === 'thumbs';
                });
                stringsEntry = dirContent.find(function (entry) {
                  return entry.name === 'strings';
                });
                cssEntry = dirContent.find(function (entry) {
                  return entry.name === 'css';
                });
                settingsEntry = dirContent.find(function (entry) {
                  return entry.name === 'settings';
                });

                if (!imgEntry) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 22;
                return _FileSystemWrapper["default"].getDirContent(imgEntry);

              case 22:
                _context7.t0 = _context7.sent;
                _context7.next = 26;
                break;

              case 25:
                _context7.t0 = [];

              case 26:
                imgContent = _context7.t0;

                if (!docsEntry) {
                  _context7.next = 33;
                  break;
                }

                _context7.next = 30;
                return _FileSystemWrapper["default"].getDirContent(docsEntry);

              case 30:
                _context7.t1 = _context7.sent;
                _context7.next = 34;
                break;

              case 33:
                _context7.t1 = [];

              case 34:
                docsContent = _context7.t1;

                if (!thumbsEntry) {
                  _context7.next = 41;
                  break;
                }

                _context7.next = 38;
                return _FileSystemWrapper["default"].getDirContent(thumbsEntry);

              case 38:
                _context7.t2 = _context7.sent;
                _context7.next = 42;
                break;

              case 41:
                _context7.t2 = [];

              case 42:
                thumbsContent = _context7.t2;

                if (!stringsEntry) {
                  _context7.next = 49;
                  break;
                }

                _context7.next = 46;
                return _FileSystemWrapper["default"].getDirContent(stringsEntry);

              case 46:
                _context7.t3 = _context7.sent;
                _context7.next = 50;
                break;

              case 49:
                _context7.t3 = [];

              case 50:
                stringsContent = _context7.t3;

                if (!cssEntry) {
                  _context7.next = 57;
                  break;
                }

                _context7.next = 54;
                return _FileSystemWrapper["default"].getDirContent(cssEntry);

              case 54:
                _context7.t4 = _context7.sent;
                _context7.next = 58;
                break;

              case 57:
                _context7.t4 = [];

              case 58:
                cssContent = _context7.t4;

                if (!settingsEntry) {
                  _context7.next = 65;
                  break;
                }

                _context7.next = 62;
                return _FileSystemWrapper["default"].getDirContent(settingsEntry);

              case 62:
                _context7.t5 = _context7.sent;
                _context7.next = 66;
                break;

              case 65:
                _context7.t5 = [];

              case 66:
                settingsContent = _context7.t5;
                entries = [].concat((0, _toConsumableArray2["default"])(dirContent), (0, _toConsumableArray2["default"])(imgContent), (0, _toConsumableArray2["default"])(docsContent), (0, _toConsumableArray2["default"])(thumbsContent), (0, _toConsumableArray2["default"])(stringsContent), (0, _toConsumableArray2["default"])(cssContent), (0, _toConsumableArray2["default"])(settingsContent));
                return _context7.abrupt("return", _promise["default"].resolve(entries));

              case 71:
                _context7.prev = 71;
                _context7.t6 = _context7["catch"](3);
                (0, _ErrorHelper.addAdditionalDataToError)(_context7.t6, {
                  folder: foldername,
                  method: 'getAllFileEntries'
                });
                return _context7.abrupt("return", _promise["default"].reject(_context7.t6));

              case 75:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[3, 71]]);
      }));

      function getAllFileEntries() {
        return _getAllFileEntries.apply(this, arguments);
      }

      return getAllFileEntries;
    }()
  }, {
    key: "getFileEntry",
    value: function () {
      var _getFileEntry = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(filename) {
        var foldername,
            forDownload,
            fileSystem,
            filenameToQuery,
            options,
            fileEntry,
            _args8 = arguments;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                foldername = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
                forDownload = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : false;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return", _promise["default"].resolve());

              case 4:
                _context8.prev = 4;
                _context8.next = 7;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 7:
                fileSystem = _context8.sent;
                filenameToQuery = foldername && foldername !== '/' ? "".concat(foldername, "/").concat(filename) : filename;
                options = forDownload ? {
                  create: true,
                  exclusive: false
                } : {
                  create: false
                };
                _context8.next = 12;
                return _FileSystemWrapper["default"].getFileEntry(fileSystem.root, filenameToQuery, options);

              case 12:
                fileEntry = _context8.sent;
                return _context8.abrupt("return", _promise["default"].resolve(fileEntry));

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](4);
                (0, _ErrorHelper.addAdditionalDataToError)(_context8.t0, {
                  filename: filename,
                  folder: foldername,
                  method: 'getFileEntry'
                });
                return _context8.abrupt("return", _promise["default"].reject(_context8.t0));

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[4, 16]]);
      }));

      function getFileEntry(_x6) {
        return _getFileEntry.apply(this, arguments);
      }

      return getFileEntry;
    }()
  }, {
    key: "getFileURL",
    value: function () {
      var _getFileURL = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(filename) {
        var foldername,
            forDownload,
            fileSystem,
            filenameToQuery,
            options,
            fileEntry,
            _args9 = arguments;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                foldername = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
                forDownload = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : false;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt("return", _promise["default"].resolve());

              case 4:
                _context9.prev = 4;
                _context9.next = 7;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 7:
                fileSystem = _context9.sent;

                if (!foldername) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 11;
                return CordovaFileHelper.createFolder(foldername);

              case 11:
                filenameToQuery = foldername ? "".concat(foldername, "/").concat(filename) : filename;
                options = forDownload ? {
                  create: true,
                  exclusive: false
                } : {};
                _context9.next = 15;
                return _FileSystemWrapper["default"].getFileEntry(fileSystem.root, filenameToQuery, options);

              case 15:
                fileEntry = _context9.sent;
                return _context9.abrupt("return", _promise["default"].resolve(fileEntry.toURL()));

              case 19:
                _context9.prev = 19;
                _context9.t0 = _context9["catch"](4);
                (0, _ErrorHelper.addAdditionalDataToError)(_context9.t0, {
                  filename: filename,
                  folder: foldername,
                  forDownload: forDownload,
                  method: 'getFileURL'
                });
                return _context9.abrupt("return", _promise["default"].reject(_context9.t0));

              case 23:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[4, 19]]);
      }));

      function getFileURL(_x7) {
        return _getFileURL.apply(this, arguments);
      }

      return getFileURL;
    }()
  }, {
    key: "clearAllFolders",
    value: function () {
      var _clearAllFolders = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
        var foldersToDelete, _i, _foldersToDelete, folder;

        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                foldersToDelete = [LOCAL_FILENAMES.DATA_FOLDER, LOCAL_FILENAMES.UPDATE_FOLDER, LOCAL_FILENAMES.VIDEO_FOLDER, LOCAL_FILENAMES.DOWNLOAD_FOLDER];
                _i = 0, _foldersToDelete = foldersToDelete;

              case 2:
                if (!(_i < _foldersToDelete.length)) {
                  _context10.next = 14;
                  break;
                }

                folder = _foldersToDelete[_i];
                _context10.next = 6;
                return CordovaFileHelper.folderExists(folder);

              case 6:
                if (!_context10.sent) {
                  _context10.next = 11;
                  break;
                }

                _context10.next = 9;
                return CordovaFileHelper.deleteDirectory(folder);

              case 9:
                _context10.next = 11;
                return CordovaFileHelper.createFolder(folder);

              case 11:
                _i++;
                _context10.next = 2;
                break;

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function clearAllFolders() {
        return _clearAllFolders.apply(this, arguments);
      }

      return clearAllFolders;
    }()
  }, {
    key: "updateFolderExists",
    value: function () {
      var _updateFolderExists = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", CordovaFileHelper.folderExists(LOCAL_FILENAMES.UPDATE_FOLDER));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function updateFolderExists() {
        return _updateFolderExists.apply(this, arguments);
      }

      return updateFolderExists;
    }()
  }, {
    key: "dataFolderExists",
    value: function () {
      var _dataFolderExists = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", CordovaFileHelper.folderExists(LOCAL_FILENAMES.DATA_FOLDER));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function dataFolderExists() {
        return _dataFolderExists.apply(this, arguments);
      }

      return dataFolderExists;
    }()
  }, {
    key: "folderExists",
    value: function () {
      var _folderExists = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(foldername) {
        var folderEntry;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt("return", _promise["default"].resolve(true));

              case 2:
                _context13.prev = 2;
                _context13.next = 5;
                return CordovaFileHelper.getFolderEntry(foldername);

              case 5:
                folderEntry = _context13.sent;
                return _context13.abrupt("return", folderEntry !== null);

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](2);

                if (!(_context13.t0.code === 1)) {
                  _context13.next = 13;
                  break;
                }

                return _context13.abrupt("return", _promise["default"].resolve(false));

              case 13:
                (0, _ErrorHelper.addAdditionalDataToError)(_context13.t0, {
                  folder: foldername,
                  method: 'folderExists'
                });
                return _context13.abrupt("return", _promise["default"].reject(_context13.t0));

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[2, 9]]);
      }));

      function folderExists(_x8) {
        return _folderExists.apply(this, arguments);
      }

      return folderExists;
    }()
  }, {
    key: "fileExists",
    value: function () {
      var _fileExists = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(filename) {
        var foldername,
            fileEntry,
            _args14 = arguments;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                foldername = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : null;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context14.next = 3;
                  break;
                }

                return _context14.abrupt("return", _promise["default"].resolve(true));

              case 3:
                _context14.prev = 3;
                _context14.next = 6;
                return CordovaFileHelper.getFileEntry(filename, foldername);

              case 6:
                fileEntry = _context14.sent;
                return _context14.abrupt("return", fileEntry !== null);

              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14["catch"](3);
                return _context14.abrupt("return", _promise["default"].resolve(false));

              case 13:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[3, 10]]);
      }));

      function fileExists(_x9) {
        return _fileExists.apply(this, arguments);
      }

      return fileExists;
    }()
  }, {
    key: "getUpdateFolder",
    value: function () {
      var _getUpdateFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(recreate) {
        var returnValue;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return", _promise["default"].resolve());

              case 2:
                _context15.prev = 2;

                if (!recreate) {
                  _context15.next = 6;
                  break;
                }

                _context15.next = 6;
                return this.deleteDirectory(LOCAL_FILENAMES.UPDATE_FOLDER);

              case 6:
                _context15.next = 8;
                return this.createFolder(LOCAL_FILENAMES.UPDATE_FOLDER);

              case 8:
                returnValue = _context15.sent;
                _context15.next = 11;
                return this.createFolder("".concat(LOCAL_FILENAMES.UPDATE_FOLDER, "/").concat(LOCAL_FILENAMES.SUBFOLDER_CSS));

              case 11:
                _context15.next = 13;
                return this.createFolder("".concat(LOCAL_FILENAMES.UPDATE_FOLDER, "/").concat(LOCAL_FILENAMES.SUBFOLDER_SETTINGS));

              case 13:
                _context15.next = 15;
                return this.createFolder("".concat(LOCAL_FILENAMES.UPDATE_FOLDER, "/").concat(LOCAL_FILENAMES.SUBFOLDER_STRINGS));

              case 15:
                _context15.next = 17;
                return this.createFolder("".concat(LOCAL_FILENAMES.UPDATE_FOLDER, "/").concat(LOCAL_FILENAMES.SUBFOLDER_IMG));

              case 17:
                _context15.next = 19;
                return this.createFolder("".concat(LOCAL_FILENAMES.UPDATE_FOLDER, "/").concat(LOCAL_FILENAMES.SUBFOLDER_DOCS));

              case 19:
                _context15.next = 21;
                return this.createFolder("".concat(LOCAL_FILENAMES.UPDATE_FOLDER, "/").concat(LOCAL_FILENAMES.SUBFOLDER_THUMBS));

              case 21:
                return _context15.abrupt("return", returnValue);

              case 24:
                _context15.prev = 24;
                _context15.t0 = _context15["catch"](2);
                (0, _ErrorHelper.addAdditionalDataToError)(_context15.t0, {
                  recreate: recreate,
                  method: 'getUpdateFolder'
                });
                return _context15.abrupt("return", _promise["default"].reject(_context15.t0));

              case 28:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[2, 24]]);
      }));

      function getUpdateFolder(_x10) {
        return _getUpdateFolder.apply(this, arguments);
      }

      return getUpdateFolder;
    }()
  }, {
    key: "getDownloadFolder",
    value: function () {
      var _getDownloadFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context16.next = 2;
                  break;
                }

                return _context16.abrupt("return", _promise["default"].resolve());

              case 2:
                _context16.prev = 2;
                return _context16.abrupt("return", this.createFolder(LOCAL_FILENAMES.DOWNLOAD_FOLDER));

              case 6:
                _context16.prev = 6;
                _context16.t0 = _context16["catch"](2);
                (0, _ErrorHelper.addAdditionalDataToError)(_context16.t0, {
                  method: 'getDownloadFolder'
                });
                return _context16.abrupt("return", _promise["default"].reject(_context16.t0));

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[2, 6]]);
      }));

      function getDownloadFolder() {
        return _getDownloadFolder.apply(this, arguments);
      }

      return getDownloadFolder;
    }()
  }, {
    key: "getDownloadFolderPath",
    value: function getDownloadFolderPath() {
      return downloadFolderPath;
    }
  }, {
    key: "moveFilesFromFolder",
    value: function () {
      var _moveFilesFromFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(fromFolder, toFolder, files) {
        var fileSystem, fromFolderEntry, i, filename;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt("return");

              case 2:
                _context17.prev = 2;
                _context17.next = 5;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 5:
                fileSystem = _context17.sent;
                _context17.next = 8;
                return _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, fromFolder, {});

              case 8:
                fromFolderEntry = _context17.sent;
                i = 0;

              case 10:
                if (!(i < files.length)) {
                  _context17.next = 23;
                  break;
                }

                filename = files[i];
                _context17.t0 = _FileSystemWrapper["default"];
                _context17.t1 = fileSystem.root;
                _context17.next = 16;
                return _FileSystemWrapper["default"].getFileEntry(fileSystem.root, "".concat(fromFolder, "/").concat(filename));

              case 16:
                _context17.t2 = _context17.sent;
                _context17.t3 = "".concat(toFolder, "/").concat(filename);
                _context17.next = 20;
                return _context17.t0.moveDirectoryOrFile.call(_context17.t0, _context17.t1, _context17.t2, _context17.t3);

              case 20:
                i++;
                _context17.next = 10;
                break;

              case 23:
                _context17.next = 29;
                break;

              case 25:
                _context17.prev = 25;
                _context17.t4 = _context17["catch"](2);
                console.error("Error moving files from ".concat(fromFolder, " to ").concat(toFolder), _context17.t4);
                throw _context17.t4;

              case 29:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[2, 25]]);
      }));

      function moveFilesFromFolder(_x11, _x12, _x13) {
        return _moveFilesFromFolder.apply(this, arguments);
      }

      return moveFilesFromFolder;
    }()
  }, {
    key: "copyFilesFromFolder",
    value: function () {
      var _copyFilesFromFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(fromFolder, toFolder, files) {
        var _this = this;

        var _ret;

        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context20.next = 2;
                  break;
                }

                return _context20.abrupt("return", []);

              case 2:
                _context20.prev = 2;
                return _context20.delegateYield( /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
                  var fileSystem, directoryEntry, dirContent, nonExistingFiles, imgEntry, docsEntry, thumbsEntry, stringsEntry, cssEntry, settingsEntry, imgContent, docsContent, thumbsContent, stringsContent, cssContent, settingsContent, promises, _loop, i;

                  return _regenerator["default"].wrap(function _callee19$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          _context19.next = 2;
                          return _FileSystemWrapper["default"].requestFileSystem();

                        case 2:
                          fileSystem = _context19.sent;
                          _context19.next = 5;
                          return _FileSystemWrapper["default"].getDirectoryEntry(fileSystem.root, fromFolder, {});

                        case 5:
                          directoryEntry = _context19.sent;
                          _context19.next = 8;
                          return _FileSystemWrapper["default"].getDirContent(directoryEntry);

                        case 8:
                          dirContent = _context19.sent;
                          nonExistingFiles = [];
                          imgEntry = dirContent.find(function (entry) {
                            return entry.name === 'img';
                          });
                          docsEntry = dirContent.find(function (entry) {
                            return entry.name === 'docs';
                          });
                          thumbsEntry = dirContent.find(function (entry) {
                            return entry.name === 'thumbs';
                          });
                          stringsEntry = dirContent.find(function (entry) {
                            return entry.name === 'strings';
                          });
                          cssEntry = dirContent.find(function (entry) {
                            return entry.name === 'css';
                          });
                          settingsEntry = dirContent.find(function (entry) {
                            return entry.name === 'settings';
                          });

                          if (!imgEntry) {
                            _context19.next = 22;
                            break;
                          }

                          _context19.next = 19;
                          return _FileSystemWrapper["default"].getDirContent(imgEntry);

                        case 19:
                          _context19.t0 = _context19.sent;
                          _context19.next = 23;
                          break;

                        case 22:
                          _context19.t0 = [];

                        case 23:
                          imgContent = _context19.t0;

                          if (!docsEntry) {
                            _context19.next = 30;
                            break;
                          }

                          _context19.next = 27;
                          return _FileSystemWrapper["default"].getDirContent(docsEntry);

                        case 27:
                          _context19.t1 = _context19.sent;
                          _context19.next = 31;
                          break;

                        case 30:
                          _context19.t1 = [];

                        case 31:
                          docsContent = _context19.t1;

                          if (!thumbsEntry) {
                            _context19.next = 38;
                            break;
                          }

                          _context19.next = 35;
                          return _FileSystemWrapper["default"].getDirContent(thumbsEntry);

                        case 35:
                          _context19.t2 = _context19.sent;
                          _context19.next = 39;
                          break;

                        case 38:
                          _context19.t2 = [];

                        case 39:
                          thumbsContent = _context19.t2;

                          if (!stringsEntry) {
                            _context19.next = 46;
                            break;
                          }

                          _context19.next = 43;
                          return _FileSystemWrapper["default"].getDirContent(stringsEntry);

                        case 43:
                          _context19.t3 = _context19.sent;
                          _context19.next = 47;
                          break;

                        case 46:
                          _context19.t3 = [];

                        case 47:
                          stringsContent = _context19.t3;

                          if (!cssEntry) {
                            _context19.next = 54;
                            break;
                          }

                          _context19.next = 51;
                          return _FileSystemWrapper["default"].getDirContent(cssEntry);

                        case 51:
                          _context19.t4 = _context19.sent;
                          _context19.next = 55;
                          break;

                        case 54:
                          _context19.t4 = [];

                        case 55:
                          cssContent = _context19.t4;

                          if (!settingsEntry) {
                            _context19.next = 62;
                            break;
                          }

                          _context19.next = 59;
                          return _FileSystemWrapper["default"].getDirContent(settingsEntry);

                        case 59:
                          _context19.t5 = _context19.sent;
                          _context19.next = 63;
                          break;

                        case 62:
                          _context19.t5 = [];

                        case 63:
                          settingsContent = _context19.t5;
                          promises = [];

                          _loop = function _loop(i) {
                            promises.push(new _promise["default"]( /*#__PURE__*/function () {
                              var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(resolve, reject) {
                                var filename, existingEntry;
                                return _regenerator["default"].wrap(function _callee18$(_context18) {
                                  while (1) {
                                    switch (_context18.prev = _context18.next) {
                                      case 0:
                                        filename = files[i];

                                        if (filename.startsWith('img')) {
                                          existingEntry = imgContent.find(function (imgEntry) {
                                            return 'img/' + imgEntry.name === filename;
                                          });
                                        } else if (filename.startsWith('docs')) {
                                          existingEntry = docsContent.find(function (docsEntry) {
                                            return 'docs/' + docsEntry.name === filename;
                                          });
                                        } else if (filename.startsWith('thumbs')) {
                                          existingEntry = thumbsContent.find(function (thumbsEntry) {
                                            return 'thumbs/' + thumbsEntry.name === filename;
                                          });
                                        } else if (filename.startsWith('strings')) {
                                          existingEntry = stringsContent.find(function (stringsEntry) {
                                            return 'strings/' + stringsEntry.name === filename;
                                          });
                                        } else if (filename.startsWith('css')) {
                                          existingEntry = cssContent.find(function (cssEntry) {
                                            return 'css/' + cssEntry.name === filename;
                                          });
                                        } else if (filename.startsWith('settings')) {
                                          existingEntry = settingsContent.find(function (settingsEntry) {
                                            return 'settings/' + settingsEntry.name === filename;
                                          });
                                        } else {
                                          existingEntry = dirContent.find(function (dirEntry) {
                                            return dirEntry.name === filename;
                                          });
                                        } // console.log(`copying file from ${fromFolder}/${filename} to ${toFolder}/${filename}`)
                                        // console.log(`file exist? ${await this.fileExists(filename, fromFolder)}, target folder exists? ${await this.folderExists(toFolder)}, target exists? ${await this.fileExists(filename, toFolder)}`)


                                        if (existingEntry) {
                                          _context18.next = 6;
                                          break;
                                        }

                                        // if (!(await this.fileExists(filename, fromFolder))) {
                                        nonExistingFiles.push(filename);
                                        _context18.next = 9;
                                        break;

                                      case 6:
                                        _context18.next = 8;
                                        return _this.copyFile(fileSystem.root, "".concat(fromFolder, "/").concat(filename), fileSystem.root, "".concat(toFolder, "/").concat(filename), true, existingEntry);

                                      case 8:
                                        resolve();

                                      case 9:
                                      case "end":
                                        return _context18.stop();
                                    }
                                  }
                                }, _callee18);
                              }));

                              return function (_x17, _x18) {
                                return _ref.apply(this, arguments);
                              };
                            }()));
                          };

                          for (i = 0; i < files.length; i++) {
                            _loop(i);
                          }

                          _context19.next = 69;
                          return _promise["default"].all(promises);

                        case 69:
                          return _context19.abrupt("return", {
                            v: nonExistingFiles
                          });

                        case 70:
                        case "end":
                          return _context19.stop();
                      }
                    }
                  }, _callee19);
                })(), "t0", 4);

              case 4:
                _ret = _context20.t0;

                if (!((0, _typeof2["default"])(_ret) === "object")) {
                  _context20.next = 7;
                  break;
                }

                return _context20.abrupt("return", _ret.v);

              case 7:
                _context20.next = 13;
                break;

              case 9:
                _context20.prev = 9;
                _context20.t1 = _context20["catch"](2);
                console.error("Error copying files from ".concat(fromFolder, " to ").concat(toFolder), _context20.t1);
                throw _context20.t1;

              case 13:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[2, 9]]);
      }));

      function copyFilesFromFolder(_x14, _x15, _x16) {
        return _copyFilesFromFolder.apply(this, arguments);
      }

      return copyFilesFromFolder;
    }()
  }, {
    key: "copyFolder",
    value: function () {
      var _copyFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21(fromName, toName) {
        var deleteTarget,
            create,
            _fileSystem,
            dirEntry,
            _args21 = arguments;

        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                deleteTarget = _args21.length > 2 && _args21[2] !== undefined ? _args21[2] : true;
                create = _args21.length > 3 && _args21[3] !== undefined ? _args21[3] : false;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context21.next = 4;
                  break;
                }

                return _context21.abrupt("return");

              case 4:
                _context21.prev = 4;

                if (!deleteTarget) {
                  _context21.next = 8;
                  break;
                }

                _context21.next = 8;
                return this.deleteDirectory(toName);

              case 8:
                _context21.next = 10;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 10:
                _fileSystem = _context21.sent;
                _context21.next = 13;
                return _FileSystemWrapper["default"].getDirectoryEntry(_fileSystem.root, fromName, {
                  create: create
                });

              case 13:
                dirEntry = _context21.sent;
                _context21.next = 16;
                return _FileSystemWrapper["default"].copyDirectoryOrFile(_fileSystem.root, dirEntry, toName);

              case 16:
                return _context21.abrupt("return", _promise["default"].resolve());

              case 19:
                _context21.prev = 19;
                _context21.t0 = _context21["catch"](4);
                (0, _ErrorHelper.addAdditionalDataToError)(_context21.t0, {
                  fromName: fromName,
                  toName: toName,
                  deleteTarget: deleteTarget,
                  create: create,
                  method: 'moveFolder'
                });
                return _context21.abrupt("return", _promise["default"].reject(_context21.t0));

              case 23:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[4, 19]]);
      }));

      function copyFolder(_x19, _x20) {
        return _copyFolder.apply(this, arguments);
      }

      return copyFolder;
    }()
  }, {
    key: "moveFolder",
    value: function () {
      var _moveFolder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(fromName, toName) {
        var deleteTarget,
            create,
            _fileSystem2,
            dirEntry,
            _args22 = arguments;

        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                deleteTarget = _args22.length > 2 && _args22[2] !== undefined ? _args22[2] : true;
                create = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : false;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context22.next = 4;
                  break;
                }

                return _context22.abrupt("return");

              case 4:
                _context22.prev = 4;

                if (!deleteTarget) {
                  _context22.next = 8;
                  break;
                }

                _context22.next = 8;
                return this.deleteDirectory(toName);

              case 8:
                _context22.next = 10;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 10:
                _fileSystem2 = _context22.sent;
                _context22.next = 13;
                return _FileSystemWrapper["default"].getDirectoryEntry(_fileSystem2.root, fromName, {
                  create: create
                });

              case 13:
                dirEntry = _context22.sent;
                _context22.next = 16;
                return _FileSystemWrapper["default"].moveDirectoryOrFile(_fileSystem2.root, dirEntry, toName);

              case 16:
                return _context22.abrupt("return", _promise["default"].resolve());

              case 19:
                _context22.prev = 19;
                _context22.t0 = _context22["catch"](4);
                (0, _ErrorHelper.addAdditionalDataToError)(_context22.t0, {
                  fromName: fromName,
                  toName: toName,
                  deleteTarget: deleteTarget,
                  create: create,
                  method: 'moveFolder'
                });
                return _context22.abrupt("return", _promise["default"].reject(_context22.t0));

              case 23:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[4, 19]]);
      }));

      function moveFolder(_x21, _x22) {
        return _moveFolder.apply(this, arguments);
      }

      return moveFolder;
    }()
  }, {
    key: "moveFile",
    value: function () {
      var _moveFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23(fromName, toName) {
        var deleteTarget,
            create,
            _fileSystem3,
            dirEntry,
            _args23 = arguments;

        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                deleteTarget = _args23.length > 2 && _args23[2] !== undefined ? _args23[2] : true;
                create = _args23.length > 3 && _args23[3] !== undefined ? _args23[3] : false;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context23.next = 4;
                  break;
                }

                return _context23.abrupt("return");

              case 4:
                _context23.prev = 4;

                if (!deleteTarget) {
                  _context23.next = 8;
                  break;
                }

                _context23.next = 8;
                return this.deleteFile(toName);

              case 8:
                _context23.next = 10;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 10:
                _fileSystem3 = _context23.sent;
                _context23.next = 13;
                return _FileSystemWrapper["default"].getFileEntry(_fileSystem3.root, fromName, {
                  create: create
                });

              case 13:
                dirEntry = _context23.sent;
                _context23.next = 16;
                return _FileSystemWrapper["default"].moveDirectoryOrFile(_fileSystem3.root, dirEntry, toName);

              case 16:
                return _context23.abrupt("return", _promise["default"].resolve());

              case 19:
                _context23.prev = 19;
                _context23.t0 = _context23["catch"](4);
                (0, _ErrorHelper.addAdditionalDataToError)(_context23.t0, {
                  fromName: fromName,
                  toName: toName,
                  deleteTarget: deleteTarget,
                  create: create,
                  method: 'moveFile'
                });
                return _context23.abrupt("return", _promise["default"].reject(_context23.t0));

              case 23:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[4, 19]]);
      }));

      function moveFile(_x23, _x24) {
        return _moveFile.apply(this, arguments);
      }

      return moveFile;
    }()
  }, {
    key: "copyFile",
    value: function () {
      var _copyFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24(fromDirEntry, fromName, toDirEntry, toName) {
        var deleteTarget,
            fileEntryToUse,
            fileEntry,
            _args24 = arguments;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                deleteTarget = _args24.length > 4 && _args24[4] !== undefined ? _args24[4] : true;
                fileEntryToUse = _args24.length > 5 && _args24[5] !== undefined ? _args24[5] : null;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context24.next = 4;
                  break;
                }

                return _context24.abrupt("return", _promise["default"].resolve());

              case 4:
                _context24.prev = 4;

                if (!deleteTarget) {
                  _context24.next = 8;
                  break;
                }

                _context24.next = 8;
                return this.deleteFile(toName, toDirEntry.name);

              case 8:
                _context24.t0 = fileEntryToUse;

                if (_context24.t0) {
                  _context24.next = 13;
                  break;
                }

                _context24.next = 12;
                return _FileSystemWrapper["default"].getFileEntry(fromDirEntry, fromName, {
                  create: false
                });

              case 12:
                _context24.t0 = _context24.sent;

              case 13:
                fileEntry = _context24.t0;
                _context24.next = 16;
                return _FileSystemWrapper["default"].copyDirectoryOrFile(toDirEntry, fileEntry, toName);

              case 16:
                return _context24.abrupt("return", _promise["default"].resolve());

              case 19:
                _context24.prev = 19;
                _context24.t1 = _context24["catch"](4);
                (0, _ErrorHelper.addAdditionalDataToError)(_context24.t1, {
                  fromDirEntry: fromDirEntry,
                  fromName: fromName,
                  toDirEntry: toDirEntry,
                  toName: toName,
                  deleteTarget: deleteTarget,
                  method: 'copyFile'
                });
                return _context24.abrupt("return", _promise["default"].reject(_context24.t1));

              case 23:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this, [[4, 19]]);
      }));

      function copyFile(_x25, _x26, _x27, _x28) {
        return _copyFile.apply(this, arguments);
      }

      return copyFile;
    }()
  }, {
    key: "readTextFile",
    value: function () {
      var _readTextFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25(filename) {
        var foldername,
            expectedMd5,
            fileEntryToUse,
            fileEntry,
            string,
            md5,
            _args25 = arguments;
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                foldername = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : null;
                expectedMd5 = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : null;
                fileEntryToUse = _args25.length > 3 ? _args25[3] : undefined;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context25.next = 5;
                  break;
                }

                return _context25.abrupt("return", _promise["default"].resolve());

              case 5:
                if (filename) {
                  _context25.next = 7;
                  break;
                }

                return _context25.abrupt("return", _promise["default"].resolve());

              case 7:
                _context25.prev = 7;
                _context25.t0 = fileEntryToUse;

                if (_context25.t0) {
                  _context25.next = 13;
                  break;
                }

                _context25.next = 12;
                return CordovaFileHelper.getFileEntry(filename, foldername);

              case 12:
                _context25.t0 = _context25.sent;

              case 13:
                fileEntry = _context25.t0;

                if (expectedMd5) {
                  _context25.next = 18;
                  break;
                }

                return _context25.abrupt("return", _FileReaderWriterWrapper["default"].readFileAsText(fileEntry));

              case 18:
                _context25.next = 20;
                return _FileReaderWriterWrapper["default"].readFileAsText(fileEntry);

              case 20:
                string = _context25.sent;
                _context25.next = 23;
                return _FileReaderWriterWrapper["default"].getMd5(string);

              case 23:
                md5 = _context25.sent;

                if (!(md5 !== expectedMd5)) {
                  _context25.next = 26;
                  break;
                }

                throw new Error("file ".concat(filename, " has  unexpected md5 ").concat(md5, " instead of ").concat(expectedMd5));

              case 26:
                return _context25.abrupt("return", string);

              case 27:
                _context25.next = 34;
                break;

              case 29:
                _context25.prev = 29;
                _context25.t1 = _context25["catch"](7);
                (0, _ErrorHelper.addAdditionalDataToError)(_context25.t1, {
                  filename: filename,
                  folder: foldername,
                  method: 'readTextFile'
                });
                console.log('error while reading text file', filename, _context25.t1);
                return _context25.abrupt("return", _promise["default"].reject(_context25.t1));

              case 34:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, null, [[7, 29]]);
      }));

      function readTextFile(_x29) {
        return _readTextFile.apply(this, arguments);
      }

      return readTextFile;
    }()
    /**
     * Works for text.
     *
     * Check yourself if it also works for binary data. Once you know, write down your findings right here where this
     * doc is written, please.
     *
     *    Android 4.*     unknown
     *    Android 5+      unknown
     *    iOS 9           unknown
     *    iOS 10+         unknown
     */

  }, {
    key: "writeToFile",
    value: function () {
      var _writeToFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26(data, filename, foldername) {
        var baseDir, fileEntry;
        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context26.next = 2;
                  break;
                }

                return _context26.abrupt("return", _promise["default"].reject(new Error('Writing files is not supported in browser')));

              case 2:
                _context26.prev = 2;
                _context26.next = 5;
                return CordovaFileHelper.getFolderEntry(foldername, true);

              case 5:
                baseDir = _context26.sent;
                _context26.next = 8;
                return _FileSystemWrapper["default"].getFileEntry(baseDir, filename, {
                  create: true,
                  exclusive: false
                });

              case 8:
                fileEntry = _context26.sent;
                console.log('writing to file:', fileEntry.toURL());
                return _context26.abrupt("return", _FileReaderWriterWrapper["default"].writeToFile(fileEntry, data));

              case 13:
                _context26.prev = 13;
                _context26.t0 = _context26["catch"](2);
                (0, _ErrorHelper.addAdditionalDataToError)(_context26.t0, {
                  data: data,
                  filename: filename,
                  folder: foldername,
                  method: 'writeToFile'
                });
                console.log('error while writing data to file', data, _context26.t0);
                return _context26.abrupt("return", _promise["default"].reject(_context26.t0));

              case 18:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[2, 13]]);
      }));

      function writeToFile(_x30, _x31, _x32) {
        return _writeToFile.apply(this, arguments);
      }

      return writeToFile;
    }()
  }, {
    key: "downloadFile",
    value: function () {
      var _downloadFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27(remoteUrl, basedir, localFilename) {
        var md5,
            returnContent,
            onProgress,
            fileEntry,
            localPath,
            ft,
            file,
            calculatedMd5,
            content,
            _args27 = arguments;
        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                md5 = _args27.length > 3 && _args27[3] !== undefined ? _args27[3] : null;
                returnContent = _args27.length > 4 && _args27[4] !== undefined ? _args27[4] : false;
                onProgress = _args27.length > 5 && _args27[5] !== undefined ? _args27[5] : null;
                _context27.prev = 3;
                _context27.next = 6;
                return _FileSystemWrapper["default"].getFileEntry(basedir, localFilename, {
                  create: true,
                  exclusive: false
                });

              case 6:
                fileEntry = _context27.sent;
                _context27.next = 12;
                break;

              case 9:
                _context27.prev = 9;
                _context27.t0 = _context27["catch"](3);
                console.error('Couldn\'t get file entry for ', basedir, localFilename);

              case 12:
                _context27.prev = 12;
                localPath = fileEntry.toURL();
                ft = new _FileTransferWrapper["default"]();
                _context27.next = 17;
                return ft.download(remoteUrl, localPath, onProgress, true, {
                  headers: {
                    Authorization: "Basic ".concat(window.btoa("".concat(_config["default"].defaultUser, ":").concat(_config["default"].defaultPassword)))
                  }
                });

              case 17:
                _context27.next = 19;
                return _FileSystemWrapper["default"].getFileEntry(basedir, localFilename, {
                  create: false
                });

              case 19:
                file = _context27.sent;

                if (!md5) {
                  _context27.next = 26;
                  break;
                }

                _context27.next = 23;
                return _FileReaderWriterWrapper["default"].getMd5Hash(file);

              case 23:
                calculatedMd5 = _context27.sent;

                if (!(calculatedMd5 !== md5)) {
                  _context27.next = 26;
                  break;
                }

                return _context27.abrupt("return", _promise["default"].reject(new Error('md5 not the same', {
                  remoteUrl: remoteUrl,
                  md5: md5,
                  calculatedMd5: calculatedMd5
                })));

              case 26:
                if (!returnContent) {
                  _context27.next = 31;
                  break;
                }

                _context27.next = 29;
                return _FileReaderWriterWrapper["default"].readFileAsText(fileEntry);

              case 29:
                content = _context27.sent;
                return _context27.abrupt("return", _promise["default"].resolve(content));

              case 31:
                return _context27.abrupt("return", _promise["default"].resolve());

              case 34:
                _context27.prev = 34;
                _context27.t1 = _context27["catch"](12);
                (0, _ErrorHelper.addAdditionalDataToError)(_context27.t1, {
                  remoteUrl: remoteUrl,
                  basedir: basedir,
                  localFilename: localFilename,
                  md5: md5,
                  returnContent: returnContent,
                  onProgress: onProgress,
                  method: 'downloadFile'
                }); // delete partially downloaded file if any

                _context27.prev = 37;

                if (!fileEntry) {
                  _context27.next = 41;
                  break;
                }

                _context27.next = 41;
                return _FileSystemWrapper["default"].removeFile(fileEntry);

              case 41:
                _context27.next = 46;
                break;

              case 43:
                _context27.prev = 43;
                _context27.t2 = _context27["catch"](37);
                console.error("error deleting partially downloaded file from ".concat(remoteUrl, " to ").concat(localFilename), _context27.t2);

              case 46:
                console.error("error downloading file from ".concat(remoteUrl, " to ").concat(localFilename), _context27.t1);
                return _context27.abrupt("return", _promise["default"].reject(_context27.t1));

              case 48:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, null, [[3, 9], [12, 34], [37, 43]]);
      }));

      function downloadFile(_x33, _x34, _x35) {
        return _downloadFile.apply(this, arguments);
      }

      return downloadFile;
    }()
  }]);
  return CordovaFileHelper;
}();

var _default = CordovaFileHelper;
exports["default"] = _default;